import { useTranslation } from 'react-i18next';

import { Badge, SimplePopover, Text } from '@fly/core';
import { FlySvgSprite } from '@fly/svg';

import { formatDownloadCount } from '../../utils/formatDownloadCount';

export function DistributionPopover({
  downloadCount,
}: {
  downloadCount: number;
}) {
  const { t } = useTranslation();
  return (
    <SimplePopover
      trigger={
        <div className='flex cursor-default items-center gap-fly-1'>
          <FlySvgSprite name='distribution' size={16} />
        </div>
      }
      rootProps={{ openOnHover: true }}
      contentProps={{
        align: 'center',
        variant: 'classic',
        color: 'neutral',
        children: (
          <div className='flex min-w-[187px] items-center justify-between gap-fly-5'>
            <Text
              size='2'
              color='neutral'
              className='font-bold text-(---text-color)'
            >
              {t('app.dashboard.releases.downloads_label', {
                defaultValue: 'Downloads',
              })}
            </Text>
            <Badge
              variant='soft'
              color='neutral'
              size='1'
              iconStart={<FlySvgSprite name='download' size={12} />}
            >
              {formatDownloadCount(downloadCount)}
            </Badge>
          </div>
        ),
      }}
    />
  );
}
